import React,{useEffect, useState} from "react";
import {
    Avatar,
    Paper,
    Table,
    TableBody,
    TableCell,
    tableCellClasses,
    TableContainer,
    TableRow
} from "@mui/material";
import {styled} from "@mui/material/styles";
import axios from "axios";
import Appbar from "../Appbar";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));
const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const EmployList = ()=>{
    const [employslist , setEmployslist] = React.useState([]);
    useEffect(()=>{
        axios.get("https://app.zhivay.com/api/get_employslist.php")
            .then(respone => {
                setEmployslist(respone.data);
            })
            .catch(error => console.log(error));
    },'')
    return (
        <div>
            <Appbar/>
            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 250,maxHeight:'80%',overflowY:'auto',direction:"rtl"}} dir="rtl" >
                    <TableBody>
                        {employslist.map(list=>(
                            <StyledTableRow
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <StyledTableCell>
                                    <Avatar
                                        alt={list.es_name}
                                        src={list.es_img}
                                        sx={{ width: 56, height: 56 }}
                                    />
                                </StyledTableCell>
                                <StyledTableCell sx={{textAlign:"right"}}>
                                    {list.es_name}
                                </StyledTableCell>
                            </StyledTableRow >
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    )
}
export default EmployList;
